interface CardImageSource {
  tcgplayer_id: string | null;
  source_image_url?: string | null;
}

export function getCardImageUrl(card: CardImageSource) {
  if (card.source_image_url) {
    const normalized = card.source_image_url.replace(/\/$/, "");
    if (/\.(webp|png|jpe?g)(?:[?#].*)?$/i.test(normalized)) {
      return normalized;
    }
    return `${normalized}/high.webp`;
  }

  if (card.tcgplayer_id) {
    return `https://product-images.tcgplayer.com/fit-in/437x610/filters:quality(95)/${card.tcgplayer_id}.jpg`;
  }
  return `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="437" height="610" viewBox="0 0 437 610"><rect width="437" height="610" rx="16" fill="#e2e8f0"/><text x="218.5" y="305" text-anchor="middle" fill="#475569" font-family="sans-serif" font-size="22">Image unavailable</text></svg>')}`;
}

